<span id="magic-container" [style.fontSize]="fontSize" [attr.av-data]="avData">
    <div class="magic-button" (click)="handleClick($event)">
        <img src="assets/img/achievements/magic.svg" />
        <div class="label">{{ title }}</div>
    </div>
</span>
